module.exports = __webpack_public_path__ + "img/r4.c1a09fb1.svg";